<!-- NO PCP SELECTED -->
<section class="CareTeamCard">
  <div class="CareTeamCard__Header">
    <h6 class="t-bold" [innerHTML]="title"></h6>
  </div>
  <div class="u-flex">
    <div class="CareTeamCard__Icon">
      <icon
        [name]="config.icon"
        [config]="{
          size: config.icon_size,
          set: config.icon_set,
          format: 'svg'
        }"
      >
      </icon>
    </div>
    <div class="u-flex u-alignCenter">
      <p class="t-bold" [innerHTML]="noProviderText"></p>
    </div>
  </div>

  <lib-care-card-footer
    [config]="config"
    [providerType]="providerType"
    [textToDisplay]="addProviderText"
    (changePCPClicked)="addPCPClicked.emit()"
  ></lib-care-card-footer>
</section>
